// extracted by mini-css-extract-plugin
export default {"overviewSVG":"Overview_overviewSVG__ZuPuC"};